/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NewEnrollmentRow } from './NewEnrollmentRow';
import {
    NewEnrollmentRowFromJSON,
    NewEnrollmentRowFromJSONTyped,
    NewEnrollmentRowToJSON,
    NewEnrollmentRowToJSONTyped,
} from './NewEnrollmentRow';

/**
 * 
 * @export
 * @interface WidgetDataNewEnrollmentsWidgetData
 */
export interface WidgetDataNewEnrollmentsWidgetData {
    /**
     * 
     * @type {string}
     * @memberof WidgetDataNewEnrollmentsWidgetData
     */
    $type?: WidgetDataNewEnrollmentsWidgetDataTypeEnum;
    /**
     * 
     * @type {Array<NewEnrollmentRow>}
     * @memberof WidgetDataNewEnrollmentsWidgetData
     */
    items: Array<NewEnrollmentRow>;
}


/**
 * @export
 */
export const WidgetDataNewEnrollmentsWidgetDataTypeEnum = {
    NewEnrollments: 'new-enrollments'
} as const;
export type WidgetDataNewEnrollmentsWidgetDataTypeEnum = typeof WidgetDataNewEnrollmentsWidgetDataTypeEnum[keyof typeof WidgetDataNewEnrollmentsWidgetDataTypeEnum];


/**
 * Check if a given object implements the WidgetDataNewEnrollmentsWidgetData interface.
 */
export function instanceOfWidgetDataNewEnrollmentsWidgetData(value: object): value is WidgetDataNewEnrollmentsWidgetData {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function WidgetDataNewEnrollmentsWidgetDataFromJSON(json: any): WidgetDataNewEnrollmentsWidgetData {
    return WidgetDataNewEnrollmentsWidgetDataFromJSONTyped(json, false);
}

export function WidgetDataNewEnrollmentsWidgetDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetDataNewEnrollmentsWidgetData {
    if (json == null) {
        return json;
    }
    return {
        
        '$type': json['$type'] == null ? undefined : json['$type'],
        'items': ((json['items'] as Array<any>).map(NewEnrollmentRowFromJSON)),
    };
}

export function WidgetDataNewEnrollmentsWidgetDataToJSON(json: any): WidgetDataNewEnrollmentsWidgetData {
    return WidgetDataNewEnrollmentsWidgetDataToJSONTyped(json, false);
}

export function WidgetDataNewEnrollmentsWidgetDataToJSONTyped(value?: WidgetDataNewEnrollmentsWidgetData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        '$type': value['$type'],
        'items': ((value['items'] as Array<any>).map(NewEnrollmentRowToJSON)),
    };
}

